module.exports = __webpack_public_path__ + "media/images/favicon-528c53b28eaf1dbc5f05a4a8cfa6d21f.ico";